export const chatStyles = {
  card: {
    width: '100%',
    height: '100%',
    borderRadius: '20px',
    overflow: 'hidden',
    boxShadow: 4,
    bgcolor: '#DFE2E9',
    display: 'flex',
    flexDirection: 'column',
  },
  floatingBallChat: {
    width: { xs: '95%', sm: '100%' },
    height: '100%',
    borderRadius: '20px',
    overflow: 'hidden',
    boxShadow: 4,
    bgcolor: '#DFE2E9',
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: 'white',
    p: 2,
    position: 'relative' as const,
  },
  avatar: {
    mr: 1,
    width: 47,
    height: 47,
  },
  title: {
    fontFamily: 'Montserrat',
    fontWeight: 700,
    fontSize: '22px',
    lineHeight: '30px',
    letterSpacing: '1px',
    textAlign: 'center',
  },
  messagesContainer: {
    height: '100%',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    px: 2,
    py: 2,
    animation: 'fadeInSlideUp 0.3s ease-in-out',
    '&::-webkit-scrollbar': {
      width: '8px',
      backgroundColor: '#DFE2E9',
      borderRadius: '8px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#B0B8C1',
      borderRadius: '8px',
      minHeight: '24px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: '#8A99A8',
    },
    scrollbarWidth: 'thin',
    scrollbarColor: '#B0B8C1 #DFE2E9',
    '& > *': {
      flexShrink: 0,
    },
  },
  inputContainer: {
    display: 'flex',
    alignItems: 'center',
    bgcolor: 'white',
    px: 2,
    py: 1.5,
  },
  input: {
    fontSize: { xs: 14, sm: 16 },
    flex: 1,
    pr: 1,
    mr: { xs: 1, sm: 2 },
    bgcolor: '#FDFDFD',
    borderRadius: '8px',
    p: 1,
    '& .MuiInputBase-input': {
      fontFamily: 'Montserrat',
      fontWeight: 500,
      fontSize: { xs: '14px', sm: '16px' },
      lineHeight: { xs: '20px', sm: '28px' },
      letterSpacing: '0px',
      color: '#28272C',
      overflowWrap: 'break-word',
      wordBreak: 'break-word',
      maxHeight: '120px',
      overflowY: 'auto',
      '&::-webkit-scrollbar': {
        width: '4px',
      },
      '&::-webkit-scrollbar-track': {
        background: 'transparent',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#B0B8C1',
        borderRadius: '4px',
      },
    },
    '& .MuiInputBase-input::placeholder': {
      fontFamily: 'Montserrat',
      fontWeight: 500,
      fontSize: { xs: '14px', sm: '16px' },
      lineHeight: { xs: '20px', sm: '28px' },
      letterSpacing: '0px',
      color: '#6C7393',
      opacity: 1,
    },
  },
  sendButton: {
    color: '#999EB0',
    transform: 'rotate(0deg)',
    padding: '4px',
    marginLeft: '-8px',
    marginBottom: '-4px',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  controlButton: {
    color: '#28272C',
    padding: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '28px',
    height: '28px',
    minWidth: '28px',
    minHeight: '28px',
    '&:hover': {
      backgroundColor: 'rgba(40, 39, 44, 0.1)'
    }
  },
} as const; 